import React, { useMemo, useState, useContext } from 'react'
import { Location, useLocation, useSearchParams } from 'react-router-dom'

import { YStack, XStack } from 'tamagui'

import { DialogContext } from '@newComponents/Dialog/Dialog'

import { SignInScreenTokenForm } from './SignInScreenTokenForm'
import { SignInScreenEmailPasswordForm } from './SignInScreenEmailPasswordForm'

export const SignInScreenContent = () => {
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const dialogContext = useContext(DialogContext)

  const [inputEmail, setInputEmail] = useState(
    () => searchParams.get('email') || ''
  )

  const signInMethod = useMemo<'email' | 'password'>(() => {
    const method = searchParams.get('method')

    return ['email', 'password'].includes(method || '')
      ? (method as 'email' | 'password')
      : 'email'
  }, [searchParams.get('method')])

  const routerState = useMemo(
    () => ({
      state: {
        backgroundLocation: location.state?.backgroundLocation as
          | Location
          | undefined,
        authRedirectPath:
          (location.state?.authRedirectPath as string) ||
          searchParams.get('authRedirectPath') ||
          undefined,
      },

      replace: true,
    }),
    [location, searchParams]
  )

  return (
    <YStack gap='$6' flex={1}>
      <YStack
        flex={1}
        gap='$8'
        paddingHorizontal={dialogContext.open ? 0 : '$8'}
      >
        <SignInForm
          initialEmail={inputEmail}
          setEmail={setInputEmail}
          method={signInMethod}
          authRedirectPath={routerState.state?.authRedirectPath}
        />
      </YStack>
    </YStack>
  )
}

const SignInForm = ({
  initialEmail,
  setEmail,
  method,
  authRedirectPath,
}: {
  initialEmail?: string
  setEmail?: (email: string) => any
  method: 'email' | 'password'
  authRedirectPath?: string
}) => {
  if (method === 'email') {
    return (
      <SignInScreenTokenForm
        initialEmail={initialEmail}
        setEmail={setEmail}
        authRedirectPath={authRedirectPath}
      />
    )
  }

  return (
    <SignInScreenEmailPasswordForm
      initialEmail={initialEmail}
      setEmail={setEmail}
    />
  )
}

export default SignInScreenContent
